import CryptoJS from "crypto-js";
import axios from "axios";
import { HmacSHA1, MD5 } from "crypto-js";
import { openSessionExpiredModal } from "../utils/functions";
//import { history } from "../routes/history";
//import packageJson from "../../package.json";
import { getCookie } from "../utils/cookie";

import {
  decryptAES,
  encryptAES,
  encryptAESKeyRSA,
  generateAESKey,
  generateIV,
} from "../utils/encryptionUtils";
import AuthStore from "../store/AuthStore";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

//Axios interceptor for APIs using AES encryption
const apiClient = axios.create({
  baseURL: BASE_URL,
});

apiClient.defaults.unsafeHeaders = ["Date"];
apiClient.defaults.timeout = 360000;
apiClient.interceptors.request.use(
  async (request) => {
    let iv = null;
    let aesKey = null;

    await AuthStore.ensurePublicKey();

    const publicKeyPem = AuthStore.publicKeyData.publicKey;

    if (!AuthStore.aesKey) {
      aesKey = generateAESKey();
      AuthStore.setData("aesKey", aesKey);
    } else {
      aesKey = AuthStore.aesKey;
    }

    const aesKeyBase64 = CryptoJS.enc.Base64.stringify(aesKey);
    const encryptedAESKey = encryptAESKeyRSA(publicKeyPem, aesKeyBase64);
    request.headers["X-ENC-KEY"] = encryptedAESKey;

    request.headers["Content-Type"] = "text/plain";

    if (["post", "put"].includes(request.method)) {
      iv = generateIV();
      const requestBody = JSON.stringify(request.data);
      const encryptedBody = encryptAES(requestBody, aesKey, iv);
      request.headers["Content-Type"] = "text/plain";
      request.data = encryptedBody;
    }

    const token = getCookie("token");
    const verb = request.method.toLocaleUpperCase();
    let payloadMd5 = "";

    // if (request.url === "/userProfilePics" || request.headers.isform) {
    //   payloadMd5 = MD5("");
    // } else {
    //   payloadMd5 = MD5(request.data);
    // }

    payloadMd5 = MD5(request.data);

    const currentDate = new Date().toUTCString();
    const payloadSign = HmacSHA1(
      verb + API_KEY + currentDate + payloadMd5,
      getCookie("secreteKey") || ""
    ).toString();

    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${token}`,
      "pwmapp-date": currentDate,
      "pwmapp-api-key": API_KEY,
      "pwmapp-payloadsign": payloadSign,
    };
    return request;
  },
  (err) => {
    throw err;
  }
);

apiClient.interceptors.response.use(
  async (response) => {
    const encryptedText = response.data;

    try {
      const decrypted = decryptAES(encryptedText, AuthStore.aesKey);
      response.data = JSON.parse(decrypted);
      return response;
    } catch (error) {
      throw error;
    }
  },
  (error) => {
    if (error.response) {
      const decrypted = decryptAES(error.response.data, AuthStore.aesKey);
      error.response.data = JSON.parse(decrypted);
    }

    if (error.response?.status === 401) {
      if (getCookie("token")) {
        openSessionExpiredModal();
        // This will open logout warning modal
        // And after clicking Okay button in modal or on outside click the logged in user will get logged out
        throw error;
      }
      throw error;
    }
    if (
      error.response?.status === 500 &&
      !error.config.url.includes("pointOfContacts")
    ) {
      throw error;
    }
    throw error;
  }
);

//Axios interceptor for APIs without AES encryption
export const plainApiClient = axios.create({
  baseURL: BASE_URL,
});

plainApiClient.defaults.unsafeHeaders = ["Date"];
plainApiClient.defaults.timeout = 360000;
plainApiClient.interceptors.request.use(
  (request) => {
    const token = getCookie("token");
    const verb = request.method.toLocaleUpperCase();
    let payloadMd5 = "";

    if (request.url === "/userProfilePics" || request.headers.isform) {
      payloadMd5 = MD5("");
    } else {
      payloadMd5 = MD5(JSON.stringify(request.data));
    }

    const currentDate = new Date().toUTCString();
    const payloadSign = HmacSHA1(
      verb + API_KEY + currentDate + payloadMd5,
      getCookie("secreteKey") || ""
    ).toString();

    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${token}`,
      "pwmapp-date": currentDate,
      "pwmapp-api-key": API_KEY,
      "pwmapp-payloadsign": payloadSign,
    };
    return request;
  },
  (err) => {
    throw err;
  }
);

plainApiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      if (getCookie("token")) {
        openSessionExpiredModal();
        // This will open logout warning modal
        // And after clicking Okay button in modal or on outside click the logged in user will get logged out
        throw error;
      }
      throw error;
    }
    throw error;
  }
);

export default apiClient;
